import * as React from "react";
import { useField, useFormikContext } from "formik";
import { DateInput, DateInputProps } from "../inputs/dateInput";

export const DateField = (props: DateInputProps) => {
    const { id, name, label, onChange, disabled, ...rest } = props;
    const [_, meta] = useField({ id, name });
    const formik = useFormikContext<any>();

    const { error } = meta;

    const handleChange = (dateValue: string) => {
        formik.setFieldValue(name, dateValue);
        onChange?.(dateValue);
    };

    return (
        <DateInput
            name={name}
            label={label}
            onChange={handleChange}
            error={!!error}
            helperText={error}
            value={_.value}
            disabled={disabled}
            {...rest}
        />
    );
};
